type SelectedParcel = {
	parcel_address?: string | null
	mun_name?: string | null
	area_square_feet?: number | string | null
}

/** Keep the analysis address consistent with the selected-lot panel. */
export function formatParcelAddress(parcel: SelectedParcel): string {
	return [parcel.parcel_address, parcel.mun_name].filter(Boolean).join(", ")
}

/** Seed a new draft without turning its cadastral total into a saved override. */
export function comparableAnalysisSubjectFromParcels(parcels: SelectedParcel[]) {
	const addresses = [...new Set(parcels.map(formatParcelAddress).filter(Boolean))]
	const areas = parcels.map(parcel => {
		const value = parcel.area_square_feet
		return value == null || value === "" ? null : Number(value)
	})
	const complete = areas.length > 0 && areas.every(area => area != null && Number.isFinite(area) && area >= 0)
	return {
		address: addresses.length ? addresses.join("; ") : undefined,
		parcelAreaSqft: complete ? areas.reduce<number>((sum, area) => sum + area!, 0) : null,
	}
}

/** Suggest a worksheet name from available location facts, without inventing an address. */
export function comparableAnalysisNameFromParcels(parcels: SelectedParcel[], title: string): string {
	const distinct = (values: (string | null | undefined)[]) => [
		...new Set(values.map(value => value?.trim()).filter(Boolean)),
	]
	const addresses = distinct(parcels.map(parcel => parcel.parcel_address)).join("; ")
	const cities = distinct(parcels.map(parcel => parcel.mun_name)).join("; ")
	return [addresses, cities, title].filter(Boolean).join(" - ").slice(0, 200)
}
